import actionTypes from '../actions/actionTypes';
import { getSalesItemName } from '../utils';

export const INITIAL_STATE = {
  loading: false,
  error: null,
  data: [],
};

export const mapManagerDetailsDivisions = ({ items, divisionsMasterList = {} }) =>
  items.reduce((acc, item) => {
    const name = getSalesItemName(item?.id, divisionsMasterList);

    if (name) {
      const newItem = { ...item, name };
      acc.push(newItem);
    }

    return acc;
  }, []);

const divisionsPerDesignerReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MANAGER_DIVISIONS_PER_DESIGNER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.MANAGER_DIVISIONS_PER_DESIGNER_SUCCESS:
      return {
        loading: false,
        error: null,
        data: Array.isArray(payload?.items) ? mapManagerDetailsDivisions(payload) : [],
      };
    case actionTypes.MANAGER_DIVISIONS_PER_DESIGNER_ERROR:
      return {
        error: payload,
        loading: false,
        data: [],
      };
    default:
      return state;
  }
};

export default divisionsPerDesignerReducer;
